export default {
    common: {
        loading: {
            es: 'Cargando',
            en: 'Loading',
            it: 'Caricamento',
            fr: 'Chargement',
            de: 'Wird geladen',
            da: 'Indlæser',
            pt: 'Carregando',
            pl: 'Ładowanie',
            sv: 'Laddar',
        },
    },
    translate: {
        title: {
            es: 'Traducir',
            en: 'Translate',
            it: 'Traduci',
            fr: 'Traduire',
            de: 'Übersetzen',
            da: 'Oversæt',
            pt: 'Traduzir',
            pl: 'Tłumacz',
            sv: 'Översätt',
        },
        from: {
            es: 'De',
            en: 'From',
            it: 'Dal',
            fr: 'De',
            de: 'Von',
            da: 'Fra',
            pt: 'De',
            pl: 'Z',
            sv: 'Från',
        },
        to: {
            es: 'a',
            en: 'to',
            it: 'allo',
            fr: 'à',
            de: 'nach',
            da: 'til',
            pt: 'para',
            pl: 'na',
            sv: 'till',
        },
        languageNotDetected: {
            es: 'Idioma no detectado',
            en: 'Source language not detected',
            it: 'Lingua sorgente non rilevata',
            fr: 'Langue source non détectée',
            de: 'Quellsprache nicht erkannt',
            da: 'Kildesprog ikke registreret',
            pt: 'Idioma de origem não detectado',
            pl: 'Nie wykryto języka źródłowego',
            sv: 'Källspråket kunde inte identifieras',
        },
        errors: {
            'no-results': {
                message: {
                    es: 'No pudimos realizar la traducción, ',
                    en: 'We could not perform the translation, ',
                    it: 'Non siamo riusciti a eseguire la traduzione, ',
                    fr: "Nous n'avons pas pu effectuer la traduction, ",
                    de: 'Wir konnten die Übersetzung nicht durchführen, ',
                    da: 'Vi kunne ikke udføre oversættelsen, ',
                    pt: 'Não foi possível realizar a tradução, ',
                    pl: 'Nie udało się wykonać tłumaczenia, ',
                    sv: 'Vi kunde inte utföra översättningen, ',
                },
                suggestion: {
                    es: 'intenta nuevamente.',
                    en: 'try again.',
                    it: 'riprova.',
                    fr: 'essayez à nouveau.',
                    de: 'versuchen Sie es erneut.',
                    da: 'prøv igen.',
                    pt: 'tente novamente.',
                    pl: 'spróbuj ponownie.',
                    sv: 'försök igen.',
                },
            },
        },
    },
    listen: {
        title: {
            es: 'Escuchar',
            en: 'Listen',
            it: 'Ascoltare',
            fr: 'écouter',
            de: 'Abspielen',
            da: 'Lyt',
            pt: 'Ouvir',
            pl: 'Słuchaj',
            sv: 'Lyssna',
        },
        playing: {
            es: 'Reproduciendo',
            en: 'Playing',
            it: 'Riproduzione',
            fr: 'Lecture',
            de: 'Wiedergabe',
            da: 'Afspiller',
            pt: 'Reproduzindo',
            pl: 'Odtwarzanie',
            sv: 'Spelar upp',
        },
        errors: {
            'no-results': {
                message: {
                    es: 'No pudimos realizar la conversión, ',
                    en: 'We could not perform the conversion, ',
                    it: 'Non siamo riusciti a eseguire la conversione, ',
                    fr: "Nous n'avons pas pu effectuer la conversion, ",
                    de: 'Wir konnten die Umwandlung nicht durchführen, ',
                    da: 'Vi kunne ikke udføre konverteringen, ',
                    pt: 'Não foi possível realizar a conversão, ',
                    pl: 'Nie udało się wykonać konwersji, ',
                    sv: 'Vi kunde inte utföra konverteringen, ',
                },
                suggestion: {
                    es: 'intenta nuevamente.',
                    en: 'try again.',
                    it: 'riprova.',
                    fr: 'essayez à nouveau.',
                    de: 'versuchen Sie es erneut.',
                    da: 'prøv igen.',
                    pt: 'tente novamente.',
                    pl: 'spróbuj ponownie.',
                    sv: 'försök igen.',
                },
            },
        },
    },
    dictionary: {
        errors: {
            'no-results': {
                message: {
                    es: 'No hay resultados, intenta con otra búsqueda.',
                    en: 'No results, try another search.',
                    it: "Nessun risultato, prova un'altra ricerca.",
                    fr: 'Aucun résultat, essayez une autre recherche.',
                    de: 'Keine Ergebnisse, versuchen Sie es mit einer anderen Suche.',
                    da: 'Ingen resultater, prøv en anden søgning.',
                    pt: 'Nenhum resultado, tente outra busca.',
                    pl: 'Brak wyników, spróbuj innego wyszukiwania.',
                    sv: 'Inga resultat, försök med en annan sökning.',
                },
            },
        },
    },
    'ai-integrations': {
        errors: {
            'no-results': {
                message: {
                    es: 'Algo salió mal. Intenta nuevamente. Recuerda que esta función está en fase BETA, por lo que puede devolver datos inesperados.',
                    en: 'Something went wrong. Please try again. Remember that this feature is in BETA, so it may return unexpected data.',
                    it: 'Qualcosa è andato storto. Per favore riprova. Ricorda che questa funzione è in fase BETA, quindi potrebbe restituire dati inattesi.',
                    fr: "Quelque chose s'est mal passé. Veuillez réessayer. N'oubliez pas que cette fonction est en phase BETA, elle peut donc renvoyer des données inattendues.",
                    de: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut. Denken Sie daran, dass diese Funktion in der BETA-Phase ist und unerwartete Daten zurückgeben kann.',
                    da: 'Noget gik galt. Prøv venligst igen. Husk at denne funktion er i BETA, så den kan returnere uventede data.',
                    pt: 'Algo deu errado. Tente novamente. Lembre-se de que este recurso está em fase BETA, portanto pode retornar dados inesperados.',
                    pl: 'Coś poszło nie tak. Spróbuj ponownie. Pamiętaj, że ta funkcja jest w fazie BETA, więc może zwracać nieoczekiwane dane.',
                    sv: 'Något gick fel. Försök igen. Kom ihåg att den här funktionen är i BETA, så den kan returnera oväntade data.',
                },
            },
            'empty-response': {
                message: {
                    es: 'Hmm, parece que no pude generar una respuesta esta vez. ¿Intentamos de nuevo?',
                    en: "Hmm, I wasn't able to generate a response this time. Shall we try again?",
                    it: 'Hmm, non sono riuscito a generare una risposta questa volta. Proviamo di nuovo?',
                    fr: "Hmm, je n'ai pas pu générer une réponse cette fois. Essayons encore?",
                    de: 'Hmm, ich konnte diesmal keine Antwort generieren. Sollen wir es nochmal versuchen?',
                    da: 'Hmm, jeg kunne ikke generere et svar denne gang. Skal vi prøve igen?',
                    pt: 'Hmm, não consegui gerar uma resposta desta vez. Vamos tentar de novo?',
                    pl: 'Hmm, tym razem nie udało mi się wygenerować odpowiedzi. Spróbujemy ponownie?',
                    sv: 'Hmm, jag kunde inte generera ett svar den här gången. Ska vi försöka igen?',
                },
            },
            'invalid-response': {
                message: {
                    es: 'Algo no funcionó como esperaba. ¿Probamos otra vez?',
                    en: "Something didn't work as expected. Shall we try again?",
                    it: 'Qualcosa non ha funzionato come previsto. Proviamo di nuovo?',
                    fr: "Quelque chose n'a pas fonctionné comme prévu. Essayons encore?",
                    de: 'Etwas hat nicht wie erwartet funktioniert. Sollen wir es nochmal versuchen?',
                    da: 'Noget fungerede ikke som forventet. Skal vi prøve igen?',
                    pt: 'Algo não funcionou como esperado. Vamos tentar de novo?',
                    pl: 'Coś nie zadziałało zgodnie z oczekiwaniami. Spróbujemy ponownie?',
                    sv: 'Något fungerade inte som förväntat. Ska vi försöka igen?',
                },
            },
        },
        retry: {
            es: 'Intentar de nuevo',
            en: 'Try again',
            it: 'Riprova',
            fr: 'Réessayer',
            de: 'Nochmal versuchen',
            da: 'Prøv igen',
            pt: 'Tentar novamente',
            pl: 'Spróbuj ponownie',
            sv: 'Försök igen',
        },
        loading: {
            es: {
                generating: 'Generando respuesta',
                processing: 'Procesando',
                wait: 'Por favor espere',
                getting: 'Obteniendo datos',
                analyzing: 'Analizando datos',
            },
            en: {
                generating: 'Generating response',
                processing: 'Processing',
                wait: 'Please wait',
                getting: 'Getting data',
                analyzing: 'Analyzing data',
            },
            de: {
                generating: 'Antwort wird generiert',
                processing: 'Verarbeitung',
                wait: 'Bitte warten',
                getting: 'Daten werden abgerufen',
                analyzing: 'Daten werden analysiert',
            },
            fr: {
                generating: 'Génération de la réponse',
                processing: 'Traitement',
                wait: 'Veuillez patienter',
                getting: 'Récupération des données',
                analyzing: 'Analyse des données',
            },
            it: {
                generating: 'Generazione della risposta',
                processing: 'Elaborazione',
                wait: 'Attendere prego',
                getting: 'Recupero dei dati',
                analyzing: 'Analisi dei dati',
            },
            pt: {
                generating: 'Gerando resposta',
                processing: 'Processando',
                wait: 'Por favor, aguarde',
                getting: 'Obtendo dados',
                analyzing: 'Analisando dados',
            },
            da: {
                generating: 'Genererer svar',
                processing: 'Behandler',
                wait: 'Vent venligst',
                getting: 'Henter data',
                analyzing: 'Analyserer data',
            },
            pl: {
                generating: 'Generowanie odpowiedzi',
                processing: 'Przetwarzanie',
                wait: 'Proszę czekać',
                getting: 'Pobieranie danych',
                analyzing: 'Analizowanie danych',
            },
            sv: {
                generating: 'Genererar svar',
                processing: 'Bearbetar',
                wait: 'Vänta',
                getting: 'Hämtar data',
                analyzing: 'Analyserar data',
            },
        },
    },
};
